export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/village/contract/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
          data
        });
      },

      getInfo(data) {
          return http.json({
              url: `/village/contract/get?id=${data.id}`
          })
      },

      save(data){
          return http.json({
              url: '/village/contract/save',
              data
          })
      },

      remove(params){
          return http.json({
              url: '/village/contract/delete',
              params
          })
      },

  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/villageContract.js